import { render, staticRenderFns } from "./GrHeadline.vue?vue&type=template&id=19108d8e&scoped=true&"
import script from "./GrHeadline.vue?vue&type=script&lang=ts&"
export * from "./GrHeadline.vue?vue&type=script&lang=ts&"
import style0 from "./GrHeadline.vue?vue&type=style&index=0&id=19108d8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19108d8e",
  null
  
)

export default component.exports